import { render, staticRenderFns } from "./ConceptPaymentForm.vue?vue&type=template&id=0975344e&"
import script from "./ConceptPaymentForm.vue?vue&type=script&lang=js&"
export * from "./ConceptPaymentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports